import { Directive, ElementRef, EventEmitter, Output, HostListener } from '@angular/core';

@Directive({
  selector: '[appScrollToEnd]'
})
export class ScrollToEndDirective {
  // Event emitter to notify when the user reaches the bottom
  @Output() scrollToEnd = new EventEmitter<void>();

  constructor(private el: ElementRef) { }

  @HostListener('scroll', ['$event'])
  onScroll(event: Event) {
    const target = event.target as HTMLElement;
    if (target.scrollTop + target.clientHeight >= target.scrollHeight) {
      this.scrollToEnd.emit();
    }
  }
}